// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../app/fonts/8-bit/8bitlimr.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../app/images/border-image.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../app/images/button-background.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../app/images//background.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body {
  width: 100%;
  height: 100%;
  margin: 0px;
  padding: 0px;
  overflow-x: hidden;
  overflow-y: hidden;

  font-family: "retro";
  letter-spacing: 5px;
  font-weight: 500;
  font-stretch: expanded;
  background-color: black;
  --lost: #ff0000b3;
  --background: rgba(14, 14, 14, 0.7);
  --main: rgba(13, 52, 68, 0.7);
  --main-dark: rgba(6, 21, 29, 0.8);
  --label-background: #000000b3;
  --input-background: #080808b3;
  --label-error: #ff0000b3;
  --label-active: rgba(5, 185, 240, 0.9);
  --label-hover: rgba(224, 240, 5, 0.9);
  --primary: var(--main);
  --primary-dark: var(--main-dark);
  --primary-bright: #086e88;
  --secondary: #1a97b6;
  --secondary-dark: #006079;
  --secondary-bright: #00beee;
  --outline: #08cf12;
  --font-color: #17c3ee;
  --font-color-dark: #23b2d6;
  --font-color-bright: #61dfff;
  letter-spacing: 5px;
  line-height: 1;
  --font-family: "retro";
  --box-shadow: 0 14px 16px rgba(0, 0, 0, 0.3);
  --font-size: 20px;
  --glow: 0 0 10px var(--secondary-bright), 0 0 20px var(--secondary-bright),
    0 0 30px var(--secondary-dark), 0 0 40px var(--secondary-dark),
    0 0 50px var(--secondary-dark), 0 0 60px var(--secondary-dark),
    0 0 70px var(--secondary-dark);

  --font-size-small: 0.8vw;
  --font-size-medium: 1vw;
  --font-size-large: 1.3vw;
  --font-size-xlarge: 1.6vw;

  --font-size-screen-title: 3vw;
  --font-size-game-title: 5vw;

  --font-size-form-label: var(--font-size-large);
  --font-size-form-input: var(--font-size-large);

  --font-size-vkb-title: 50px;
  --font-size-vkb-input: 40px;
  --font-size-vkb-key: 30px;
}

@font-face {
  font-family: "retro";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

@media (max-width: 1250px) {
  /* … */
  body {
    --font-size-small: 1vh;
    --font-size-medium:1.5vh;
    --font-size-large: 2vh;
    --font-size-xlarge: 3vh;
    --font-size-game-title: 5vh;
  }
}

.border-1 {
  border-style: solid;
  border-image-source: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  border-image-repeat: repeat;
  border-image-slice: 6 6 6 6;
  border-image-width: 18px;
  border-width: 15px;
  padding: 12px;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  /*   background: url(img/background-image.png) center;
  background-clip: padding-box;
  background-origin: padding-box; */
}

#APP {
  z-index: 1;
  position: absolute;
  width: 100%;
  height: 100%;
  margin: 0px;
  padding: 0px;
  overflow-x: hidden;
  overflow-y: hidden;
  background-color: rgba(0, 0, 0, 0.1);
  user-select: none;
}

.main-screen {
  z-index: 1000;
  width: 100%;
  height: 100%;
  margin: 0px;
  padding: 0px;
  background: none;
  display: flex;
  flex-direction: column;
}

.main-screens {
  width: 100%;
  height: 100%;
  overflow-y: scroll;
}

.menu-screen > div {
  overflow-y: scroll;
}

div:focus,
button:focus,
p:focus {
  outline: none;
}

h1.screen-title {
  text-align: left;
  margin-left: 10px;
  margin-top: 0;
  padding: 0;

  font-size: var(--font-size-screen-title);
  color: var(--font-color);
}

.menu-screen.active {
  display: grid;
}

.menu-screen.inactive {
  display: none;
}

.screens {
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  background-color: var(--background);
}

.screen-fade {
  width: 100%;
  height: 100%;
}

.screen {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}

.screen.inactive {
  display: none;
}

.screen.active {
  display: flex;
  flex-direction: column;
  animation: fadein 0.5s linear;
}

.subscreen {
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
}

.screen-switch-screen {
  height: 100%;
  width: 100%;
}

.subscreen.inactive,
.screen-switch-screen.inactive {
  display: none;
}

.subscreen.active,
.screen-switch-screen.active {
  display: block;
  animation: fadein 0.5s linear;
}

*::-webkit-scrollbar {
  width: 12px;
}

*::-webkit-scrollbar-track {
  background-color: var(--main-dark);
}

*::-webkit-scrollbar-thumb {
  background-color: var(--main);
  border: 3px solid var(--main-dark);
}
.intro-in {
  animation: intro-fade-in 2s linear;
}
.intro-out {
  animation: intro-fade-out 2s linear;
}

.screen-in {
  animation: intro-fade-in 0.25s linear;
}
.screen-out {
  animation: intro-fade-out 0.25s linear;
}

.default-button {
  padding: 20px;
  color: var(--font-color-dark);
  display: block;

  outline: none;

  border-style: solid;
  border-image-source: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  border-image-repeat: repeat;
  border-image-slice: 6 6 6 6;
  border-image-width: 18px;
  border-width: 15px;

  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___});

  background-repeat: no-repeat;
  background-clip: padding-box;
  background-size: 100% 100%;
  background-origin: padding-box;
  image-rendering: pixelated;

  padding: 12px;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;

  transition: 0.5s;
  min-width: 200px;
  font-size: var(--font-size-large);
  font-weight: bold;
  letter-spacing: 5px;
  margin-left: 15px;
  margin-right: 15px;
  font-family: var(--font-family);
  margin-bottom: 20px;
  &:hover {
    cursor: pointer;
    color: var(--font-color-bright);
    text-shadow: var(--glow);
    transition: 0.5s;
  }
  &.active {
    cursor: pointer;
    color: var(--font-color-bright);
    text-shadow: var(--glow);
    transition: 0.5s;
  }
}

.button-group {
  display: flex;
  width: 80%;
  margin: auto;
}

@keyframes intro-fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes intro-fade-out {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

@keyframes spin {
  0% {
    transform: rotate3d(0, -1, 0, 0deg);
  }
  100% {
    transform: rotate3d(0, -1, 0, 360deg);
  }
}
@keyframes fadein {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes fadeout {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

@keyframes glow {
  from {
    text-shadow: 0 0 10px var(--secondary-bright),
      0 0 20px var(--secondary-bright), 0 0 30px var(--secondary-dark),
      0 0 40px var(--secondary-dark), 0 0 50px var(--secondary-dark),
      0 0 60px var(--secondary-dark), 0 0 70px var(--secondary-dark);
  }
  to {
    text-shadow: 0 0 20px var(--secondary-bright), 0 0 30px var(--secondary),
      0 0 40px var(--secondary), 0 0 50px var(--secondary),
      0 0 60px var(--secondary), 0 0 70px var(--secondary),
      0 0 80px var(--secondary);
  }
}

.game-title {
  color: var(--secondary-dark);
  text-align: center;
  font-size: var(--font-size-game-title);
  text-shadow: var(--glow);
  padding: 0;
  margin-top: 50px;
  margin-bottom: 0;
  margin-left: 0;
  margin-right: 0;

  display: block;
}

.main-screen {
  width: calc(100% - 30px);
  height: calc(100% - 30px);
  border-style: solid;

  border-image-source: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  border-image-repeat: repeat;
  border-image-slice: 6 6 6 6;
  border-image-width: 18px;
  border-width: 15px;

  background: linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) center;

  background-repeat: no-repeat;
  background-clip: padding-box;
  background-size: cover;
  background-origin: padding-box;
  image-rendering: pixelated;
  display: block;
}
`, "",{"version":3,"sources":["webpack://./src/website/index.css"],"names":[],"mappings":"AAAA;;EAEE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;;EAElB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;EACjB,mCAAmC;EACnC,6BAA6B;EAC7B,iCAAiC;EACjC,6BAA6B;EAC7B,6BAA6B;EAC7B,wBAAwB;EACxB,sCAAsC;EACtC,qCAAqC;EACrC,sBAAsB;EACtB,gCAAgC;EAChC,yBAAyB;EACzB,oBAAoB;EACpB,yBAAyB;EACzB,2BAA2B;EAC3B,kBAAkB;EAClB,qBAAqB;EACrB,0BAA0B;EAC1B,4BAA4B;EAC5B,mBAAmB;EACnB,cAAc;EACd,sBAAsB;EACtB,4CAA4C;EAC5C,iBAAiB;EACjB;;;kCAGgC;;EAEhC,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;;EAEzB,6BAA6B;EAC7B,2BAA2B;;EAE3B,8CAA8C;EAC9C,8CAA8C;;EAE9C,2BAA2B;EAC3B,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,4CAAyC;AAC3C;;AAEA;EACE,MAAM;EACN;IACE,sBAAsB;IACtB,wBAAwB;IACxB,sBAAsB;IACtB,uBAAuB;IACvB,2BAA2B;EAC7B;AACF;;AAEA;EACE,mBAAmB;EACnB,4DAAwD;EACxD,2BAA2B;EAC3B,2BAA2B;EAC3B,wBAAwB;EACxB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,8BAA8B;EAC9B;;mCAEiC;AACnC;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,oCAAoC;EACpC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,UAAU;;EAEV,wCAAwC;EACxC,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,6BAA6B;EAC7B,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,mCAAmC;AACrC;;AAEA;EACE,qCAAqC;AACvC;AACA;EACE,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,cAAc;;EAEd,aAAa;;EAEb,mBAAmB;EACnB,4DAAwD;EACxD,2BAA2B;EAC3B,2BAA2B;EAC3B,wBAAwB;EACxB,kBAAkB;;EAElB,mDAAoD;;EAEpD,4BAA4B;EAC5B,4BAA4B;EAC5B,0BAA0B;EAC1B,8BAA8B;EAC9B,0BAA0B;;EAE1B,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,8BAA8B;;EAE9B,gBAAgB;EAChB,gBAAgB;EAChB,iCAAiC;EACjC,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;EACnB;IACE,eAAe;IACf,+BAA+B;IAC/B,wBAAwB;IACxB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,+BAA+B;IAC/B,wBAAwB;IACxB,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,UAAU;EACV,YAAY;AACd;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,mCAAmC;EACrC;EACA;IACE,qCAAqC;EACvC;AACF;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE;;;oEAGgE;EAClE;EACA;IACE;;;+BAG2B;EAC7B;AACF;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,sCAAsC;EACtC,wBAAwB;EACxB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,eAAe;;EAEf,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,mBAAmB;;EAEnB,4DAAwD;EACxD,2BAA2B;EAC3B,2BAA2B;EAC3B,wBAAwB;EACxB,kBAAkB;;EAElB;kDAC2C;;EAE3C,4BAA4B;EAC5B,4BAA4B;EAC5B,sBAAsB;EACtB,8BAA8B;EAC9B,0BAA0B;EAC1B,cAAc;AAChB","sourcesContent":["html,\r\nbody {\r\n  width: 100%;\r\n  height: 100%;\r\n  margin: 0px;\r\n  padding: 0px;\r\n  overflow-x: hidden;\r\n  overflow-y: hidden;\r\n\r\n  font-family: \"retro\";\r\n  letter-spacing: 5px;\r\n  font-weight: 500;\r\n  font-stretch: expanded;\r\n  background-color: black;\r\n  --lost: #ff0000b3;\r\n  --background: rgba(14, 14, 14, 0.7);\r\n  --main: rgba(13, 52, 68, 0.7);\r\n  --main-dark: rgba(6, 21, 29, 0.8);\r\n  --label-background: #000000b3;\r\n  --input-background: #080808b3;\r\n  --label-error: #ff0000b3;\r\n  --label-active: rgba(5, 185, 240, 0.9);\r\n  --label-hover: rgba(224, 240, 5, 0.9);\r\n  --primary: var(--main);\r\n  --primary-dark: var(--main-dark);\r\n  --primary-bright: #086e88;\r\n  --secondary: #1a97b6;\r\n  --secondary-dark: #006079;\r\n  --secondary-bright: #00beee;\r\n  --outline: #08cf12;\r\n  --font-color: #17c3ee;\r\n  --font-color-dark: #23b2d6;\r\n  --font-color-bright: #61dfff;\r\n  letter-spacing: 5px;\r\n  line-height: 1;\r\n  --font-family: \"retro\";\r\n  --box-shadow: 0 14px 16px rgba(0, 0, 0, 0.3);\r\n  --font-size: 20px;\r\n  --glow: 0 0 10px var(--secondary-bright), 0 0 20px var(--secondary-bright),\r\n    0 0 30px var(--secondary-dark), 0 0 40px var(--secondary-dark),\r\n    0 0 50px var(--secondary-dark), 0 0 60px var(--secondary-dark),\r\n    0 0 70px var(--secondary-dark);\r\n\r\n  --font-size-small: 0.8vw;\r\n  --font-size-medium: 1vw;\r\n  --font-size-large: 1.3vw;\r\n  --font-size-xlarge: 1.6vw;\r\n\r\n  --font-size-screen-title: 3vw;\r\n  --font-size-game-title: 5vw;\r\n\r\n  --font-size-form-label: var(--font-size-large);\r\n  --font-size-form-input: var(--font-size-large);\r\n\r\n  --font-size-vkb-title: 50px;\r\n  --font-size-vkb-input: 40px;\r\n  --font-size-vkb-key: 30px;\r\n}\r\n\r\n@font-face {\r\n  font-family: \"retro\";\r\n  src: url(../app/fonts/8-bit/8bitlimr.ttf);\r\n}\r\n\r\n@media (max-width: 1250px) {\r\n  /* … */\r\n  body {\r\n    --font-size-small: 1vh;\r\n    --font-size-medium:1.5vh;\r\n    --font-size-large: 2vh;\r\n    --font-size-xlarge: 3vh;\r\n    --font-size-game-title: 5vh;\r\n  }\r\n}\r\n\r\n.border-1 {\r\n  border-style: solid;\r\n  border-image-source: url(../app/images/border-image.png);\r\n  border-image-repeat: repeat;\r\n  border-image-slice: 6 6 6 6;\r\n  border-image-width: 18px;\r\n  border-width: 15px;\r\n  padding: 12px;\r\n  box-sizing: border-box;\r\n  -moz-box-sizing: border-box;\r\n  -webkit-box-sizing: border-box;\r\n  /*   background: url(img/background-image.png) center;\r\n  background-clip: padding-box;\r\n  background-origin: padding-box; */\r\n}\r\n\r\n#APP {\r\n  z-index: 1;\r\n  position: absolute;\r\n  width: 100%;\r\n  height: 100%;\r\n  margin: 0px;\r\n  padding: 0px;\r\n  overflow-x: hidden;\r\n  overflow-y: hidden;\r\n  background-color: rgba(0, 0, 0, 0.1);\r\n  user-select: none;\r\n}\r\n\r\n.main-screen {\r\n  z-index: 1000;\r\n  width: 100%;\r\n  height: 100%;\r\n  margin: 0px;\r\n  padding: 0px;\r\n  background: none;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.main-screens {\r\n  width: 100%;\r\n  height: 100%;\r\n  overflow-y: scroll;\r\n}\r\n\r\n.menu-screen > div {\r\n  overflow-y: scroll;\r\n}\r\n\r\ndiv:focus,\r\nbutton:focus,\r\np:focus {\r\n  outline: none;\r\n}\r\n\r\nh1.screen-title {\r\n  text-align: left;\r\n  margin-left: 10px;\r\n  margin-top: 0;\r\n  padding: 0;\r\n\r\n  font-size: var(--font-size-screen-title);\r\n  color: var(--font-color);\r\n}\r\n\r\n.menu-screen.active {\r\n  display: grid;\r\n}\r\n\r\n.menu-screen.inactive {\r\n  display: none;\r\n}\r\n\r\n.screens {\r\n  width: 100%;\r\n  height: 100%;\r\n  overflow-y: scroll;\r\n  overflow-x: hidden;\r\n  background-color: var(--background);\r\n}\r\n\r\n.screen-fade {\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n.screen {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 100%;\r\n  width: 100%;\r\n}\r\n\r\n.screen.inactive {\r\n  display: none;\r\n}\r\n\r\n.screen.active {\r\n  display: flex;\r\n  flex-direction: column;\r\n  animation: fadein 0.5s linear;\r\n}\r\n\r\n.subscreen {\r\n  width: 100%;\r\n  overflow-y: scroll;\r\n  overflow-x: hidden;\r\n}\r\n\r\n.screen-switch-screen {\r\n  height: 100%;\r\n  width: 100%;\r\n}\r\n\r\n.subscreen.inactive,\r\n.screen-switch-screen.inactive {\r\n  display: none;\r\n}\r\n\r\n.subscreen.active,\r\n.screen-switch-screen.active {\r\n  display: block;\r\n  animation: fadein 0.5s linear;\r\n}\r\n\r\n*::-webkit-scrollbar {\r\n  width: 12px;\r\n}\r\n\r\n*::-webkit-scrollbar-track {\r\n  background-color: var(--main-dark);\r\n}\r\n\r\n*::-webkit-scrollbar-thumb {\r\n  background-color: var(--main);\r\n  border: 3px solid var(--main-dark);\r\n}\r\n.intro-in {\r\n  animation: intro-fade-in 2s linear;\r\n}\r\n.intro-out {\r\n  animation: intro-fade-out 2s linear;\r\n}\r\n\r\n.screen-in {\r\n  animation: intro-fade-in 0.25s linear;\r\n}\r\n.screen-out {\r\n  animation: intro-fade-out 0.25s linear;\r\n}\r\n\r\n.default-button {\r\n  padding: 20px;\r\n  color: var(--font-color-dark);\r\n  display: block;\r\n\r\n  outline: none;\r\n\r\n  border-style: solid;\r\n  border-image-source: url(../app/images/border-image.png);\r\n  border-image-repeat: repeat;\r\n  border-image-slice: 6 6 6 6;\r\n  border-image-width: 18px;\r\n  border-width: 15px;\r\n\r\n  background: url(../app/images/button-background.png);\r\n\r\n  background-repeat: no-repeat;\r\n  background-clip: padding-box;\r\n  background-size: 100% 100%;\r\n  background-origin: padding-box;\r\n  image-rendering: pixelated;\r\n\r\n  padding: 12px;\r\n  box-sizing: border-box;\r\n  -moz-box-sizing: border-box;\r\n  -webkit-box-sizing: border-box;\r\n\r\n  transition: 0.5s;\r\n  min-width: 200px;\r\n  font-size: var(--font-size-large);\r\n  font-weight: bold;\r\n  letter-spacing: 5px;\r\n  margin-left: 15px;\r\n  margin-right: 15px;\r\n  font-family: var(--font-family);\r\n  margin-bottom: 20px;\r\n  &:hover {\r\n    cursor: pointer;\r\n    color: var(--font-color-bright);\r\n    text-shadow: var(--glow);\r\n    transition: 0.5s;\r\n  }\r\n  &.active {\r\n    cursor: pointer;\r\n    color: var(--font-color-bright);\r\n    text-shadow: var(--glow);\r\n    transition: 0.5s;\r\n  }\r\n}\r\n\r\n.button-group {\r\n  display: flex;\r\n  width: 80%;\r\n  margin: auto;\r\n}\r\n\r\n@keyframes intro-fade-in {\r\n  0% {\r\n    opacity: 0;\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n@keyframes intro-fade-out {\r\n  0% {\r\n    opacity: 1;\r\n  }\r\n  100% {\r\n    opacity: 0;\r\n  }\r\n}\r\n\r\n@keyframes spin {\r\n  0% {\r\n    transform: rotate3d(0, -1, 0, 0deg);\r\n  }\r\n  100% {\r\n    transform: rotate3d(0, -1, 0, 360deg);\r\n  }\r\n}\r\n@keyframes fadein {\r\n  0% {\r\n    opacity: 0;\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n@keyframes fadeout {\r\n  0% {\r\n    opacity: 1;\r\n  }\r\n  100% {\r\n    opacity: 0;\r\n  }\r\n}\r\n\r\n@keyframes glow {\r\n  from {\r\n    text-shadow: 0 0 10px var(--secondary-bright),\r\n      0 0 20px var(--secondary-bright), 0 0 30px var(--secondary-dark),\r\n      0 0 40px var(--secondary-dark), 0 0 50px var(--secondary-dark),\r\n      0 0 60px var(--secondary-dark), 0 0 70px var(--secondary-dark);\r\n  }\r\n  to {\r\n    text-shadow: 0 0 20px var(--secondary-bright), 0 0 30px var(--secondary),\r\n      0 0 40px var(--secondary), 0 0 50px var(--secondary),\r\n      0 0 60px var(--secondary), 0 0 70px var(--secondary),\r\n      0 0 80px var(--secondary);\r\n  }\r\n}\r\n\r\n.game-title {\r\n  color: var(--secondary-dark);\r\n  text-align: center;\r\n  font-size: var(--font-size-game-title);\r\n  text-shadow: var(--glow);\r\n  padding: 0;\r\n  margin-top: 50px;\r\n  margin-bottom: 0;\r\n  margin-left: 0;\r\n  margin-right: 0;\r\n\r\n  display: block;\r\n}\r\n\r\n.main-screen {\r\n  width: calc(100% - 30px);\r\n  height: calc(100% - 30px);\r\n  border-style: solid;\r\n\r\n  border-image-source: url(../app/images/border-image.png);\r\n  border-image-repeat: repeat;\r\n  border-image-slice: 6 6 6 6;\r\n  border-image-width: 18px;\r\n  border-width: 15px;\r\n\r\n  background: linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)),\r\n    url(../app/images//background.png) center;\r\n\r\n  background-repeat: no-repeat;\r\n  background-clip: padding-box;\r\n  background-size: cover;\r\n  background-origin: padding-box;\r\n  image-rendering: pixelated;\r\n  display: block;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
